import { MapDisplay } from '@/components/ui/data-display/map-display/MapDisplay';

export const MapBlock = ({ data }) => {
  return <MapDisplay data={data} apiKey={process.env.NEXT_PUBLIC_MAP_KEY} />;
};
